import { useEffect, useState } from 'react';
import axios from 'axios';
import { OptionSet } from 'src/components/Tickets/models/Tickets.interface';

export const useGetTicketApprovalStatuses = () => {
  const [ticketApprovalStatuses, setTicketApprovalStatuses] =
    useState<OptionSet[]>();
  const [isLoadingTicketApprovalStatuses, setIsLoadingTicketApprovalStatuses] =
    useState<boolean>();
  const [ticketApprovalStatusesErrors, setTicketApprovalStatusesErrors] =
    useState<unknown>();

  const getTicketApprovalStatuses = async () => {
    setIsLoadingTicketApprovalStatuses(true);
    try {
      const response = await axios.get(
        'api/option-sets/ticket-approval-statuses'
      );
      setTicketApprovalStatuses(response.data);
    } catch (error) {
      console.error(error);
      setTicketApprovalStatusesErrors(error);
    } finally {
      setIsLoadingTicketApprovalStatuses(false);
    }
  };

  useEffect(() => {
    getTicketApprovalStatuses();
  }, []);

  return {
    ticketApprovalStatuses,
    isLoadingTicketApprovalStatuses,
    ticketApprovalStatusesErrors,
  };
};
